/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class StockControl extends React.Component {

	render() {
		return (
            <div>
				{this.props.children}
			</div>
		)
	}
}
;
export default StockControl;


// WEBPACK FOOTER //
// ./src/routes/stockControl/index.js